import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Clock, User } from "lucide-react";
import api from "@/lib/api";
import useSeo from "@/lib/useSeo";

export default function BlogPost() {
  const { slug } = useParams();
  const [p, setP] = useState(null);
  useEffect(() => { api.get(`/blog_posts/${slug}`).then(({ data }) => setP(data)).catch(() => setP(false)); }, [slug]);
  useSeo({ title: p?.seo_title || p?.title, description: p?.seo_description || p?.excerpt, image: p?.cover });
  if (p === null) return <div className="max-w-3xl mx-auto px-6 py-32 text-center text-slate-400">Chargement…</div>;
  if (p === false) return <div className="max-w-3xl mx-auto px-6 py-32 text-center text-slate-500">Article introuvable. <Link to="/blog" className="text-[#0F2A6B] underline">Retour</Link></div>;
  return (
    <article className="max-w-3xl mx-auto px-4 sm:px-6 py-10">
      <Link to="/blog" className="inline-flex items-center gap-2 text-slate-500 hover:text-[#0F2A6B] text-sm mb-6"><ArrowLeft className="w-4 h-4" /> Tous les articles</Link>
      <div className="text-xs font-mono text-[#4CB944] uppercase tracking-wider">{p.category}</div>
      <h1 className="mt-3 text-3xl sm:text-4xl font-bold text-slate-900 font-head leading-tight">{p.title}</h1>
      <div className="mt-4 flex items-center gap-4 text-sm text-slate-500">
        <span className="flex items-center gap-1.5"><User className="w-4 h-4" />{p.author}</span>
        {p.read_time && <span className="flex items-center gap-1.5"><Clock className="w-4 h-4" />{p.read_time} min de lecture</span>}
      </div>
      {p.cover && <img src={p.cover} alt={p.title} className="mt-6 w-full h-80 object-cover rounded-2xl" />}
      {p.excerpt && <p className="mt-6 text-lg text-slate-700 font-medium leading-relaxed">{p.excerpt}</p>}
      <div className="mt-6 text-slate-600 leading-relaxed whitespace-pre-line text-[17px]">{p.content}</div>
    </article>
  );
}
